import { render, staticRenderFns } from "./StTeaserEventsHome.vue?vue&type=template&id=46a5f57e"
import script from "./StTeaserEventsHome.vue?vue&type=script&lang=ts"
export * from "./StTeaserEventsHome.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports